import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchFilters } from "../slices/getFiltersSlice";

export const useGetFilters = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const filtersRaw = useSelector((state) => state.filterList.filtersList);
    const loaded = useSelector((state) => state.filterList.loaded);

    useEffect(() => {
        if (!token || loaded) {
            return;
        }
        dispatch(fetchFilters({ token }));
    }, [dispatch, token, loaded]);

    return { filters: filtersRaw?.data || {} };
};